export default "__VITE_ASSET__9r41Wv54__"